import V1PreparingPage from '@/pages/v1/signUp/PreparingPage'
import V2PreparingPage from '@/pages/v2/signUp/PreparingPage'
import { useABTestVariant } from '@app-studio-web/ui/contexts/ABTestContext'
import BaselinePreparingPage from '@app-studio-web/ui/pages/signUp/PreparingPage'

interface Props {
  onPrepare?: () => Promise<{ success: boolean }>
  redirectTo?: string
}

export default function VariantPreparingPage(props: Props) {
  const { variant } = useABTestVariant()

  switch (variant) {
    case 'v1':
      return <V1PreparingPage {...props} />
    case 'v2':
      return <V2PreparingPage {...props} />
    default:
      return <BaselinePreparingPage {...props} />
  }
}
